const availableLocales = {
  de: require('@/languages/de.json'),
  en: require('@/languages/en.json'),
}

export default {
  locale: 'de',
  silentTranslationWarn: true,
  messages: availableLocales
}


// WEBPACK FOOTER //
// ./src/lib/i18n.js